@if (templateRef) {
  <ng-container [ngTemplateOutlet]="templateRef"
  [ngTemplateOutletContext]="params?.templateContext"></ng-container>
}
